const bookOnline = {
	inputs: ['first_name_input', 'last_name_input', 'email_input', 'phone_input'],
	checkboxs: ['hormone_therapy_input', 'weight_loss_input', 'wellness_coaching_input', 'food_sensitivity_input', 'nutritional_therapy_input', 'other_input'],
	submitting: false,
	updateErrorMessage(errors) {
		let message = "";
		if (errors.length === 0) {
			return;
		} else if (errors.length === 1) {
			message = `${errors[0]} is required.`;
		} else if (errors.length === 2) {
			message = `${errors[0]} and ${errors[1]} are required.`;
		} else {
			let allButLast = errors.slice(0, -1).join(', ');
			let last = errors[errors.length - 1];
			message = `${allButLast}, and ${last} are required.`;
		}
		document.getElementById('book_form_response').innerHTML = `<span class="error">${message}</span>`;
	},
	removeErrors() {
		this.inputs.forEach(id => {
			document.getElementById(id).parentElement.classList.remove('error');
		});
		document.getElementById('book_form_checkbox_label').classList.remove('error');
		document.getElementById('book_form_checkboxs').classList.remove('error');
		document.getElementById('location_input').classList.remove('error');
		document.getElementById('sms_input').classList.remove('error');
		document.getElementById('book_form_response').innerHTML = '';
	},
	checkForErrors() {
		let errors = [];
		this.inputs.forEach(id => {
			let el = document.getElementById(id);
			if (el.value === "" || el.value === undefined || el.value === null) {
				el.parentElement.classList.add('error');
				errors.push(id.replace('_input', '').replace('_', ' '));
			}
		});
		let oneChecked = false;
		this.checkboxs.forEach(id => {
			if (document.getElementById(id).checked) {
				oneChecked = true;
			}
		});
		if (!oneChecked) {
			document.getElementById('book_form_checkbox_label').classList.add('error');
			document.getElementById('book_form_checkboxs').classList.add('error');
			errors.push('at least one consultation option');
		}
		let loc = document.getElementById('location_input');
		if (loc.value === "" || loc.value === undefined || loc.value === null) {
			loc.classList.add('error');
			errors.push('location');
		}

		this.updateErrorMessage(errors);

		return errors;
	},
	formListeners() {
		let form = document.getElementById('book_form');
		form.addEventListener('submit', e => {
			e.stopImmediatePropagation();
			e.preventDefault();

			this.removeErrors();

			if (this.submitting) {
				return;
			}

			let errorsFound = this.checkForErrors();

			if (errorsFound.length === 0) {
				this.submitting = true;

				let request = new XMLHttpRequest(),
					method = 'POST',
					url = form.getAttribute('action'),
					data = new FormData(form);

				request.onreadystatechange = () => {
					if (request.readyState === 4 && request.status === 200) {
						let response = JSON.parse(request.responseText);
						if (response.success) {
							let location = document.getElementById('location_input').value;
							let firstName = document.getElementById('first_name_input').value;
							let lastName = document.getElementById('last_name_input').value;
							let email = document.getElementById('email_input').value;
							let phone = document.getElementById('phone_input').value;
							window.location.href = `/scheduling/${location}?firstName=${firstName}&lastName=${lastName}&email=${email}&phone=${phone}`;
						} else {
							document.getElementById('book_form_response').innerHTML = `<span class="error">${response.message}</span>`;
						}
					}
				};
				request.open(method, url, true);
				request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
				request.send(data);
			}
		});
		this.inputs.forEach(id => {
			document.getElementById(id).addEventListener('input', e => {
				e.target.parentElement.classList.remove('error');
			});
		});
		this.checkboxs.forEach(id => {
			document.getElementById(id).addEventListener('click', () => {
				document.getElementById('book_form_checkbox_label').classList.remove('error');
				document.getElementById('book_form_checkboxs').classList.remove('error');
			});
		});
		document.getElementById('location_input').addEventListener('click', e => {
			e.target.classList.remove('error');
		});
	},
	init() {
		if (document.getElementById('book_form')) {
			this.formListeners();
		}
	}
};

export const initBookOnline = () => bookOnline.init();